function createRandomChar(nums) {
	const charsMap = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm',
	 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'
	]
	let randomChar = ''
	for(let i = 0;i < nums;i++) {
	 randomChar = randomChar + charsMap[Math.floor(Math.random() * 26)]
	}
	return randomChar
 }
 
 export function createTicketByMj() {
	return new Promise((resolve, reject) => {
	 const tick = String(new Date().getTime()) + createRandomChar(4)
	 resolve({tick,maxentId:''})
	})
 }